import type { ComponentProps, MouseEvent } from 'react';

import { cn } from '@/lib/utils';

/**
 * Chrome shared by the editor's floating toolbars (format toolbar, table actions).
 * Carries the `format-toolbar` marker that keeps inline editing alive while a toolbar
 * control holds focus — see `isRichTextToolbarEngaged` in lib/editor-portal-targets.
 */
export function EditorToolbarSurface({
  className,
  onMouseDownCapture,
  ...props
}: ComponentProps<'div'>) {
  const handleMouseDownCapture = (event: MouseEvent<HTMLDivElement>) => {
    // Keep the editor focused for direct toolbar buttons, while allowing portaled form
    // controls to receive focus and place their caret normally.
    if (event.currentTarget.contains(event.target as Node)) {
      event.preventDefault();
    }
    onMouseDownCapture?.(event);
  };

  return (
    <div
      {...props}
      data-rich-text-editor-ui="format-toolbar"
      className={cn(
        'flex items-center gap-1 rounded-md border border-primary/20 bg-background p-1 shadow-lg',
        className,
      )}
      onMouseDownCapture={handleMouseDownCapture}
    />
  );
}
